import { RootState } from '../../rootReducer';

export const homeSettingsSelectors = {
  getSettings: (state: RootState) => state.HomeSettingsState,
};
